import { useCellState } from './CellContext'

import { CellTypeSelect } from './CellTypeSelect'
import { CellTypeText } from './CellTypeText'

/**
 * Renders a cell inside a cue.
 */
export function Cell() {
  const { col } = useCellState()

  // Determine which component to render based on column type
  if (col.type === 'select') {
    return <CellTypeSelect />
  } else {
    return <CellTypeText />
  }
}
